import { createUseStyles } from "react-jss";
import { colors } from "../../../constants/colors";

const styles = createUseStyles((theme) => ({
  skeletonWrapper: {
    width: "100%",
    padding: "24px",
    backgroundColor: colors.lightBackground,
    borderRadius: "8px",
  },
  outerContainer: {
    borderRadius: "12px",
    border: `1px solid ${colors.lightGrey}`,
    padding: "32px 30px 32px 30px",
    margin: "0px",
  },
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    maxWidth: "352px"
  },
  /* Top Section Styles */
  loyaltyHeader: {
    textAlign: "left",
    marginBottom: "16px",
    "& > *:not(:last-child)": {
      marginBottom: "8px",
    },
  },
  loyaltyTitle: {
    fontWeight: "bold",
  },
  loyaltySubtext: {
    opacity: 0.8,
  },
  pointsTable: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "32px 0px",
    borderRadius: "6px",
  },
  redeemButtonContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    width: "100%",
  },

  /* Redemption History Section */
  redemptionHistoryHeader: {
    display: "flex",
    flexDirection: "row"
  },
  redemptionHistoryHeaderLeft: {
    width: "50%"
  },
  redemptionHistoryHeaderRight: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    width: "50%",
  },
  redemptionHistoryHeader2: {
    display: "flex",
    flexDirection: "row",
    marginTop: "32px"
  },
  redemptionHistoryHeaderLeft2: {
    width: "50%"
  },
  redemptionHistoryHeaderRight2: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    width: "50%",
  },
  redemptionHistory: {
    marginTop: "32px",
  },
  sectionTitle: {
    display: "flex",
    flexDirection: "column",
    marginBottom: "16px",
    fontWeight: "bold",
  },
  tableSkeleton: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  tableRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px 16px",
    borderRadius: "6px",
    backgroundColor: colors.lightGrey,
  },
  tableRowDetails: {
    flex: 1,
    marginLeft: "16px",
    "& > *:not(:last-child)": {
      marginBottom: "4px",
    },
  },
}));

export default styles;